import React from 'react'

import { useStore } from '@frame/lib/stores/useStore'

import { ErrorContent } from './error-content'

export function ErrorPage() {
  const error = useStore(({ error }) => error)

  return <ErrorContent error={error} />
}
